// extracted by mini-css-extract-plugin
export default {"rate":"Rating_rate__N7BhU","ratePrimary":"Rating_ratePrimary__yJLSc","rateSecondary":"Rating_rateSecondary__mhAqe"};